import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import CKFinderUploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder.js';
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation.js';

/** plugins Criados */
import InsertImage from './plugins/images';
import EmbedSocial from './plugins/embed-social';
import VideoUol from './plugins/video-uol';
import VideoSpalla from './plugins/video-spalla';
import VideoYoutube from './plugins/video-youtube';
import Gallery from './plugins/gallery';
import SourceCode from './plugins/source-code';
import Audio from './plugins/audio';
import Dazn from './plugins/dazn';
import Spotify from './plugins/spotify';
import Enquetes from './plugins/enquetes';
import Amazon from './plugins/amazon';
import Riddle from './plugins/riddle';
import OneFootBall from './plugins/onefootball';
import StatsCore from './plugins/statscore';
import ExternalLinkTarget from './plugins/external-link-target';
import ArticleLinker from './plugins/article-linker';

// import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
// import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'; // <--- ADDED

export default class ClassicEditor extends ClassicEditorBase { }

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
  ExternalLinkTarget,
  Essentials,
  UploadAdapter,
  Autoformat,
  Bold,
  Italic,
  BlockQuote,
  // EasyImage,
  Heading,
  Image,
  ImageCaption,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  Link,
  List,
  InsertImage,
  CKFinder,
  CKFinderUploadAdapter,
  Indent,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  Table,
  TableToolbar,
  TextTransformation,
  EmbedSocial,
  VideoUol,
  VideoSpalla,
  VideoYoutube,
  Gallery,
  SourceCode,
  Audio,
  Dazn,
  Spotify,
  Enquetes,
  Amazon,
  Riddle,
  OneFootBall,
  StatsCore,
  ArticleLinker,
  // Alignment, // <--- ADDED
];

// Editor configuration.
ClassicEditor.defaultConfig = {
  link: {
    decorators: {
      isExternal: {
        mode: 'manual',
        label: 'Abrir em nova aba',
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        defaultValue: false
      }
    }
  },
  articleLinker: {
    endpoint: 'https://api.bs.vibra.digital/api/v1/BandArticle',
    defaultParams: {
      sort: '-@created',
      qfields: 'config.order.data.title^1000'
    },
    queryParam: 'q2',
    pageParam: 'page',
    limitParam: 'limit',
    limit: 10,
    labelPath: 'config.order.data.title',
    urlPath: 'url',
    urlBase: 'https://www.band.com.br/',
  }
};
